<template>
  <div id="app">
    <BaseLayout v-if="isAuthenticated">
      <router-view />
    </BaseLayout>
    <Login v-else />
  </div>
</template>

<script>
import BaseLayout from "@/layout/BaseLayout";
import Login from "@/views/Login";
import { isAuthenticated } from "@/auth";

export default {
  components: { BaseLayout, Login },
  data() {
    return {
      isAuthenticated: isAuthenticated()
    };
  }
};
</script>

<style lang="scss">
// TODO: move Buefy setup to separate file
@import "~@mdi/font/css/materialdesignicons.css";
$family-sans-serif: "Rubik", sans-serif;

// Set your colors
$primary: #3f51b5;

// Import Bulma's core
@import "~bulma/sass/utilities/_all";

$primary-invert: findColorInvert($primary);

// Setup $colors to use as bulma classes
$datenblatt: cyan;
$datenblatt-invert: findColorInvert($datenblatt);

$plan: deeppink;
$plan-invert: findColorInvert($plan);

$anleitung: yellow;
$anleitung-invert: findColorInvert($anleitung);

$konformitaetserklaerung: mediumblue;
$konformitaetserklaerung-invert: findColorInvert($konformitaetserklaerung);

$protokoll: darkslategray;
$protokoll-invert: findColorInvert($protokoll);

$nachweis: lime;
$nachweis-invert: findColorInvert($nachweis);

$konzept: sandybrown;
$konzept-invert: findColorInvert($konzept);

$schema: rosybrown;
$schema-invert: findColorInvert($schema);

$addColors: (
  "datenblatt": (
    $datenblatt,
    $datenblatt-invert
  ),
  "plan": (
    $plan,
    $plan-invert
  ),
  "anleitung": (
    $anleitung,
    $anleitung-invert
  ),
  "konformitaetserklaerung": (
    $konformitaetserklaerung,
    $konformitaetserklaerung-invert
  ),
  "protokoll": (
    $protokoll,
    $protokoll-invert
  ),
  "nachweis": (
    $nachweis,
    $nachweis-invert
  ),
  "konzept": (
    $konzept,
    $konzept-invert
  ),
  "schema": (
    $schema,
    $schema-invert
  )
);
$colors: map-merge($colors, $addColors);

// Links
// $link: $primary;
// $link-invert: $primary-invert;
// $link-focus-border: $primary;

// Import Bulma and Buefy styles
@import "~bulma";
@import "~buefy/src/scss/buefy";
</style>
